export default "__VITE_ASSET__Bzt6ziwK__"